import { string } from 'prop-types';

export const propTypesEmtQuestionsAndAnswers = {
  nValue: string.isRequired
};
